import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "accounts-page" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "type" }
const _hoisted_8 = {
  key: 1,
  class: "empty"
}
const _hoisted_9 = { class: "box" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "description" }
const _hoisted_15 = { class: "type" }
const _hoisted_16 = {
  key: 1,
  class: "empty"
}

import store from "@/store";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { toast } from "@/common/utils/toast";
import { DefaultTheme } from "@/common/themes";

import { userAccountByMember, userAffiliateList } from "@/common/api/rest/user";
import {
  UserAccountType,
  UserAffiliateListbyMemberType,
} from "@/common/types/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, tm } = useI18n();
const router = useRouter();

const account = ref<UserAccountType | null>(null);
const affiliate = ref<UserAffiliateListbyMemberType[] | null>(null);

const accountStatus = computed(() => ({
  ACTIVE: "Ativo",
  INACTIVE: "Inativo",
  BLOCKED: "Bloqueado",
  PAST_DUE: "Vencido",
}));

const accountType = computed(
  () => tm("technical.types") as Record<string, string>,
);

function goToAccount(account: any) {
  if (account.status === "INACTIVE") {
    toast({
      message: "Sua conta ainda não foi ativada.",
      type: "warning",
    });
    return;
  }
  store.commit("SET_TYPE", "ADMIN");
  store.commit("SET_ACCOUNT", account);
  store.commit("SET_MODULES", account.modules);
  router.push(`/${account.account_id}/home`);
}

function goToAffiliate(account: UserAffiliateListbyMemberType) {
  store.commit("SET_TYPE", account.type);
  router.push(`/${account.account_id}/home`);
}

function fecthAccount() {
  userAccountByMember(store.getters.user?.member_id)
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        account.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fecthAffiliate() {
  userAffiliateList(store.getters.user?.member_id)
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        affiliate.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => store.getters.user,
  () => {
    fecthAccount();
    fecthAffiliate();
  },
);

onMounted(() => {
  fecthAccount();
  fecthAffiliate();

  store.commit("SET_TYPE", null);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DefaultTheme), {
    "menu-active": "accounts",
    "account-status": account.value?.status
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("common.labels.my_account")), 1),
          _createElementVNode("div", _hoisted_4, [
            (account.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToAccount(account.value)))
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(account.value.name || _unref(t)("user.labels.uninformed")), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(account.value.description), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("common.labels.status")) + ": " + _toDisplayString(accountStatus.value[account.value.status]), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)("plan.texts.account_empty")), 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("plan.labels.affiliate_accounts")), 1),
          _createElementVNode("div", _hoisted_11, [
            (affiliate.value?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(affiliate.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "item",
                    onClick: ($event: any) => (goToAffiliate(item))
                  }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.account.name || _unref(t)("user.labels.uninformed")), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.account.description), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)("common.labels.type")) + ": " + _toDisplayString(accountType.value[item.type]), 1)
                  ], 8, _hoisted_12))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(t)("plan.texts.affiliate_accounts")), 1))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["account-status"]))
}
}

})